<template>
  <a class="tabs__item"  :class="{ active: tab.isActive }" @click="changeView">
    {{ tab.title }}
  </a>
</template>

<script>
export default {
  props: {
    tab: Object
  },
  methods: {
    changeView() {
      let tabs = this.$parent.tabs;
      if (!this.tab.isActive) {
        tabs.forEach(tab => {
          tab.id === this.tab.id ? tab.isActive = true : tab.isActive = false
        });
      }
    }
  }
}
</script>
